
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useLogin = (setIsLoading: (loading: boolean) => void, setAuthError: (error: string | null) => void) => {
  // Login with email and password
  const login = async (email: string, password: string): Promise<boolean> => {
    setIsLoading(true);
    setAuthError(null);
    
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      
      if (error) {
        setAuthError(error.message);
        toast.error("Inloggning misslyckades", {
          description: error.message,
        });
        return false;
      }
      
      toast.success("Du har loggats in");
      return true;
    } catch (error: any) {
      setAuthError(error.message);
      toast.error("Inloggning misslyckades", {
        description: error.message,
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // Login with one-time password (magic link)
  const loginWithOTP = async (email: string): Promise<boolean> => {
    setIsLoading(true);
    setAuthError(null);
    
    try {
      const redirectTo = `${window.location.origin}/auth`;
      
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: redirectTo,
        }
      });
      
      if (error) {
        setAuthError(error.message);
        toast.error("Kunde inte skicka inloggningslänk", {
          description: error.message,
        });
        return false;
      }
      
      toast.success("Kontrollera din e-post", {
        description: "Vi har skickat en länk för att logga in.",
      });
      return true;
    } catch (error: any) {
      setAuthError(error.message);
      toast.error("Inloggning misslyckades", {
        description: error.message,
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { login, loginWithOTP };
};
